<template>
  <div>
    <v-btn
      tile
      text
      class="ml-2 my-4 px-6 success"
      height="60"
      @click="showBanners"
      >Show view</v-btn
    >
    <v-dialog v-model="preview" content-class="custom-scroll">
      <v-sheet class="white">
        <v-container>
          <v-row v-if="view">
            <v-col
              v-for="(banner, index) in view.banners"
              :key="banner._id"
              cols="12"
              :sm="6"
              :lg="3"
              :xl="2"
            >
              <div class="d-flex justify-space-between">
                <!-- <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                    <div
                      v-bind="attrs"
                      v-on="on"
                      :class="[
                        'body-2 px-2  mr-1 white--text',
                        banner.isActive ? 'green' : 'red',
                      ]"
                    >
                      Visible
                    </div>
                  </template>
                  <span>Manual creation status</span>
                </v-tooltip> -->

                <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                    <div
                      v-bind="attrs"
                      v-on="on"
                      :class="[
                        'body-2 px-2 mr-1 white--text text-center',
                        banner.company.panelStatus ? 'green' : 'red',
                      ]"
                    >
                      API Status
                    </div>
                  </template>
                  <span>Current status of the campaing from API</span>
                </v-tooltip>

                <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                    <div
                      v-bind="attrs"
                      v-on="on"
                      :class="[
                        'body-2 px-2 mr-1 white--text text-center',
                        banner.permission ? 'green' : 'red',
                      ]"
                    >
                      Permission
                    </div>
                  </template>
                  <span
                    >Advertiser's permission to the publicate his
                    creations</span
                  >
                </v-tooltip>

                <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                    <div
                      v-bind="attrs"
                      v-on="on"
                      :class="[
                        'body-2 px-2 mr-1 white--text text-center',
                        banner.promote ? 'green' : 'red',
                      ]"
                    >
                      Show at the top
                    </div>
                  </template>
                  <span
                    >Advertiser's permission to the publicate his
                    creations</span
                  >
                </v-tooltip>

                <!-- <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                    <div
                      v-bind="attrs"
                      v-on="on"
                      :class="[
                        'body-2 px-2 white--text',
                        banner.forceShow ? 'green' : 'red',
                      ]"
                    >
                      Force
                    </div>
                  </template>
                  <span>Forced display of creations</span>
                </v-tooltip> -->
              </div>
              <Banner
                :banner="banner"
                :key="banner._id"
                :counter="index"
                class="elevation-1"
              ></Banner>
            </v-col>
          </v-row>
        </v-container>
      </v-sheet>
    </v-dialog>
  </div>
</template>

<script>
import { mapActions } from "vuex";

export default {
  data() {
    return {
      preview: false,
    };
  },
  props: {
    view: {
      type: Object,
      required: true,
    },
  },
  components: {
    Banner: () => import("@/components/Dashboard/BannerThumb"),
  },
  methods: {
    ...mapActions(["fetchView", "getViewBanners"]),
    async showBanners() {
      const id = this.view._id;
      await this.fetchView(id);
      await this.getViewBanners(id);
      this.preview = true;
    },
  },
};
</script>

<style  lang="scss">
::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.1);
  background-color: rgba(239, 63, 55, 0.1);
}

// CUSTOMSCROLLBAR END
::-webkit-scrollbar {
  -webkit-appearance: none; // you need to tweak this to make it available..
  width: 8px;
  background-color: transparent;
}

::-webkit-scrollbar-thumb {
  border: 0;
  background-color: rgba(239, 63, 55, 0.8);
  opacity: 0.4;
}
</style>
